import { Box } from "@mui/material"
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { ShowErrorToast } from "../../Common/Toast/toast";
import { StepsHeader } from "../../Common/StepsHeader/stepsHeader"
import { StepsFooter } from "../../Common/StepsFooter/stepsFooter";
import { decrementCoursesSteps, resetCoursesSteps } from "../../../Infrastructure/States/coursesStepsSlice";
import { CourseListing } from "../../CourseListing/courseListing";
import { Loader } from "../../Common/Loader/loader";
import { useEffect, useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../../Infrastructure/config";
import { cleanCourseState, setCourseDetails } from "../../../Infrastructure/States/courseDetailsSlice";
import useAuthentication from "../../../Infrastructure/States/onAuthStateChange";
import { chooseCourseCompletionModal } from "../../../Infrastructure/States/authModalsSlice";
import paths from "../../../Infrastructure/Router/paths";
import { summarySx } from "../styles";

export const Summary = () => {
    const approved = false
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { userId } = useAuthentication()
    const [isLoading, setIsLoading] = useState(false);
    const ip = useSelector((state) => state.ip.address)
    const page = useSelector((state)=> state.route.currentRoute)
    const course = useSelector((state) => state.course.courseDetails)
    const courseId = course?.courseId || null
    const courseSteps = useSelector((state) => state.courseSteps.courseSteps)
    const userData = useSelector((state) => state.userData.data)

    const handleExit = () => {
        dispatch(cleanCourseState())
        navigate(paths.dashboardPage.path)
        dispatch(resetCoursesSteps())
    }
    const handleDec = async () => {
        if (courseSteps > 1) {
            try {
                setIsLoading(true)
                const course = userData?.educator?.courses[courseId ? courseId : ''];
                if (course) {
                    dispatch(setCourseDetails({ course, courseId }));
                }
                const updateCourseStep = httpsCallable(functions, "updatestep");
                await updateCourseStep({ step: 5, courseId })
                dispatch(decrementCoursesSteps())
            } catch (error) {
                ShowErrorToast(error)
            }finally{
                setIsLoading(false)
            }
        }
    }
    const handleSubmit = async () => {
        try {
            setIsLoading(true)
            const updateCourseStatus = httpsCallable(functions, "updatecoursestatus");
            await updateCourseStatus({ courseId, status: "pending", uid: userId, isEducatorSubmit: true, ip, page });
            dispatch(cleanCourseState())
            navigate(paths.dashboardPage.path)
            dispatch(chooseCourseCompletionModal())
        } catch (err) {
            ShowErrorToast("Course isn't submitted successfully")
        } finally {
            setIsLoading(false)
        }
    }
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
         <Box sx={summarySx.root}>
            <Box sx={summarySx.headerBox}>
                <StepsHeader steps={courseSteps} handleExit={handleExit} />
            </Box>
            <Box sx={summarySx.content}>
                {
                    isLoading ? <Loader /> :
                        <CourseListing live={false} centerLoader={true}/>
                }
            </Box>
            <Box sx={summarySx.footerBox}>
                <StepsFooter
                    handleContinueClick={handleSubmit}
                    status={approved}
                    handleDec={handleDec}
                    isLoading={isLoading}
                />
            </Box>
        </Box>
    );
}